export default __webpack_public_path__ + "static/media/bgAsideMb.c3bc0d81.png";